import { Component } from '@angular/core';
import {Router} from "@angular/router";
import {TrackingService} from "../../services/tracking.service";

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css'],
    standalone: false
})
export class SearchComponent {
  public trackingCode: string = "";
  public isLoading: boolean = false;

  constructor(private router: Router, private trackingService: TrackingService) {
  }

  /**
   * Navigate to the view page with the tracking code as a route parameter.
   * @param trackingCode
   */
  submitTrackingCode(trackingCode: string) {
    if (trackingCode && trackingCode.length > 0) {
      this.isLoading = true;
      this.trackingService.recordEvent("search", {trackingCode});
      this.router.navigate(["/", trackingCode]).then(() => {})
    }
  }
}
